module.exports = __webpack_public_path__ + "img/17.3ce1111c.jpg";